import { ContentType } from '@/state/vault/domain'
import Denomination from './denomination'

export enum Currency {
  NotDefined = 'NotDefined',
  ALL = 'All',

  TJISEK = 'TJISEK',
  SEK = 'SEK',

  TJIEUR = 'TJIEUR',
  EUR = 'EUR',

  TJICHF = 'TJICHF',
  CHF = 'CHF',

  TJIUSD = 'TJIUSD',
  USD = 'USD',

  HEART = 'HEART',

  WALLETFACE = 'WALLETFACE',
  MAJBLOMMA = 'MAJBLOMMA',
  MAJBLOMMACOIN = 'MAJBLOMMACOIN'
}

export interface CurrencyInfo {
  currency: Currency | ContentType
  symbol: string
}

export interface ITopUpOption {
  label: string
  denomination: Denomination
  series: string
  icon: string
  iconScale: number
}

export interface ICurrencyConfig {
  topUpOptions: ITopUpOption[]
}

const currencyInfo: CurrencyInfo[] = [
  { currency: Currency.NotDefined, symbol: '' },
  { currency: Currency.ALL, symbol: '' },

  { currency: Currency.TJISEK, symbol: ' kr' },
  { currency: Currency.SEK, symbol: ' kr' },

  { currency: Currency.TJIEUR, symbol: '€' },
  { currency: Currency.EUR, symbol: '€' },

  { currency: Currency.TJICHF, symbol: ' CHF' },
  { currency: Currency.CHF, symbol: ' CHF' },

  { currency: Currency.TJIUSD, symbol: '$' },
  { currency: Currency.USD, symbol: ' $' },

  { currency: Currency.HEART, symbol: '' },
  { currency: Currency.MAJBLOMMA, symbol: '' },
  { currency: ContentType.Emoji, symbol: '' },
  { currency: ContentType.News, symbol: '' },
  { currency: ContentType.Tool, symbol: '' }
]

export function getCurrencyInfo(currency: string): CurrencyInfo {
  return currencyInfo.find(x => x.currency === currency)!
}

export function formatToDecimal(inputInCents: number): string {
  const sum = Math.max(0, inputInCents) / 100
  const fract = sum - Math.floor(sum)
  let output = Math.floor(sum).toString()
  if (fract > 0) {
    const fractString = String(Math.round(fract * 100)).substring(0, 2)
    output += '.' + fractString
  }

  return output
}

export default Currency
